import React from 'react'

export default function EduExp() {
  return (
    <div className='container py-5'>
        <p className='grey-text mb-3'>OVER THE YEARS</p>
        <p className='h3 fw600 mb-5'>Education & Experience</p>
        <div className='row'>
            <div className="col-sm-12 col-lg-6 mb-4">
               <p className="h5 mb-3">Education</p>
               <div className='mb-4'>
                <strong className=" mb-1">Bachelor of Engineering, Petroleum Engineering</strong>
                <p className="grey-text">Federal University of Technology, Owerri (2022/23), NIG</p>
               </div>
               <div className='mb-4'>
                <strong className="mb-1">West African Senior School Certificate Examination (WASSCE)</strong>
                <p className="grey-text">King's College, Lagos (2015), NIG</p>
               </div>
               <div className='mb-4'>
                <strong className="mb-1">Junior Senior School Certificate Examination (JSSCE)</strong>
                <p className="grey-text">Valuespring College, Lagos (2012), NIG</p>
               </div>
               
               
            </div>
            <div className="col-sm-12 col-lg-6 mb-4">
            <p className="h5 mb-3">Experience</p>
            <div className='mb-4'>
                <strong className=" mb-1">Web Developer</strong>
                <p className="grey-text">Trive, inc (2022 - present)</p>
               </div><div className='mb-4'>
                <strong className=" mb-1">Fullstack Developer</strong>
                <p className="grey-text">Oyemexchange (2021 - present)</p>
               </div>
               <div className='mb-4'>
                <strong className=" mb-1">Co-founder & Fullstack Developer</strong>
                <p className="grey-text">Raverstudio (2020 - 2022)</p>
               </div>
               <div className='mb-4'>
                <strong className="mb-1">Business Development Officer</strong>
                <p className="grey-text">Printshore NG (2020 - 2022)</p>
               </div>
               <div className='mb-4'>
                <strong className="mb-1">Business Development Intern</strong>
                <p className="grey-text">Axxela (2019 -2019)</p>
               </div>
            </div>
           
        </div>
    </div>
  )
}
